export function roundToPlaces(value: number, places: number): number {
	const coefficient = 10 ** places;
	return Math.round((value + Number.EPSILON) * coefficient) / coefficient;
}
